// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__2yfkX","radioRow":"SimpleQuestionBuilderModal_radioRow__3GWmC"};